import { Box, Stack, Typography } from '@mui/material'
import { KomejirushiMongon } from '~/components/common/KomejirushiMongon'
import { FC } from 'react'
import { staticPath } from '~/lib/$path'
import { StepContents } from '../ConnectInstagramAccount/Steps'
import { ZoomImageList } from '../ConnectInstagramAccount/ZoomImageList'
import { InnerStepper } from '../InnerStepper'

export const FourthStep: FC = () => {
  const steps: StepContents = [
    {
      label: 'Facebookページを作成する',
      content: (
        <Stack spacing={0.5}>
          <Typography variant="body2">
            ページ作成画面より、ページ名、カテゴリを入力して「Facebookページを作成」ボタンをクリックします。
          </Typography>
          <ZoomImageList paths={[staticPath.facebook_connect_steps.facebook_page.step_0_webp]} />
        </Stack>
      ),
    },
    {
      label: '作成したFacebookページとInstagramアカウントを連携する',
      content: (
        <Stack spacing={0.5}>
          <Typography variant="body2">
            ページ一覧画面より、1で作成したページを選択し、詳細画面からInstagramの連携設定画面へ進みます。
          </Typography>
          <ZoomImageList
            paths={[
              staticPath.facebook_connect_steps.facebook_page.step_1_webp,
              staticPath.facebook_connect_steps.facebook_page.step_2_webp,
              staticPath.facebook_connect_steps.facebook_page.step_3_webp,
              staticPath.facebook_connect_steps.facebook_page.step_4_webp,
              staticPath.facebook_connect_steps.facebook_page.step_5_webp,
              staticPath.facebook_connect_steps.facebook_page.step_6_webp,
              staticPath.facebook_connect_steps.facebook_page.step_7_webp,
            ]}
          />
        </Stack>
      ),
    },
    {
      label: 'Instagramアカウントの紐付け',
      content: (
        <Stack spacing={0.5}>
          <Typography variant="body2">
            紐付けたいInstagramアカウントでログイン後、マーケティング画面に戻るとリンクされたことが確認できます。リンク済みのアカウントにて、以下の画面になっていれば連携完了です。
          </Typography>
          <ZoomImageList
            paths={[
              staticPath.facebook_connect_steps.facebook_page.step_8_webp,
              staticPath.facebook_connect_steps.facebook_page.step_9_webp,
            ]}
          />
        </Stack>
      ),
    },
  ]

  return (
    <Box>
      <KomejirushiMongon
        text="既にFacebookページとInstagramアカウントの連携がお済みの方は「次のステップへ」からお進みください。"
        sx={{ mb: 2 }}
      />
      <Typography>下記画像を参照しFacebookページを作成してください。</Typography>

      <InnerStepper steps={steps} />
    </Box>
  )
}
